export default __webpack_public_path__ + "static/1-b109d7d53e188d6a3809a51023c45dd9.jpg";